/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Facility information for the receiver of the fax
 * @export
 * @interface FaxDocumentSenderSourceTag
 */
export interface FaxDocumentSenderSourceTag {
    /**
     * 
     * @type {string}
     * @memberof FaxDocumentSenderSourceTag
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof FaxDocumentSenderSourceTag
     */
    name: string;
}

/**
 * Check if a given object implements the FaxDocumentSenderSourceTag interface.
 */
export function instanceOfFaxDocumentSenderSourceTag(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function FaxDocumentSenderSourceTagFromJSON(json: any): FaxDocumentSenderSourceTag {
    return FaxDocumentSenderSourceTagFromJSONTyped(json, false);
}

export function FaxDocumentSenderSourceTagFromJSONTyped(json: any, ignoreDiscriminator: boolean): FaxDocumentSenderSourceTag {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function FaxDocumentSenderSourceTagToJSON(value?: FaxDocumentSenderSourceTag | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}

